export function getInlineLoadingMessage(confirming) {
	return confirming ? '結果確認中' : '處理中'
}

export function shouldNativeDisableInlineAction(unavailable, busy) {
	return Boolean(unavailable) && !busy
}
